// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"FollowUp7DayForm__wrapper__1-4Za","submitResult":"FollowUp7DayForm__submitResult__3-M15","toggleHeadline":"FollowUp7DayForm__toggleHeadline__1WwqY","collapseIcon":"FollowUp7DayForm__collapseIcon__DdVs9","headlineText":"FollowUp7DayForm__headlineText__U88Vn","sliderWrapper":"FollowUp7DayForm__sliderWrapper__3BLrx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FollowUp7DayForm/FollowUp7DayForm.css
// module id = 2897
// module chunks = 0